import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MyDomainsTableContainer from '../../widgets/my-domains/my-domains-table-container';
import MySendersTableContainer from '../../widgets/my-senders/my-senders-table-container';
import UnverifiedSendersContainer from
    '../../widgets/unverified-senders/unverified-senders-container';
import Widget from '../components/widget';

import { exportToCSV } from '../../dashboard/actions/dashboard-action-creators';
import { widgetsByIdSelector } from '../selectors/widget-selectors';
import { isEditModeSelector } from '../../common/selectors/ui-state-selectors';
import WidgetDescriptionMessage from '../components/widget-description-message';

const widgetMap = {
    myDomainsTable: {
        content: MyDomainsTableContainer,
        editText: `This widget displays domains of the selected group.`,
    },
    mySendersTable: {
        content: MySendersTableContainer,
        editText: `This widget displays any permitted senders that are 
                    sending on behalf of domains in My Domains.`,
    },
    unverifiedSenders: {
        content: UnverifiedSendersContainer,
        editText: `This widget displays senders that are sending on behalf of any
                    domains in My Domains. You can identify if a sender is
                    permitted or not, per domain.`
    }
};

export class WidgetContainer extends Component{
    onExportToCSV = () => {
        const { id, exportToCSV } = this.props;
        exportToCSV( id );
    };

    generateContent = ( ) => {
        const  { config, widgetDetails, canvasDataParams, isEditMode } = this.props;
        const Content = widgetMap[widgetDetails.type] ? widgetMap[widgetDetails.type].content : null;
        const editMessage = widgetMap[widgetDetails.type] ? widgetMap[widgetDetails.type].editText : null;

        return (
            <>
            {isEditMode ?
                <WidgetDescriptionMessage message={editMessage} dataAutomationId={`${widgetDetails.type}-edit-message`} />
                : (
                    <Content
                        config={config}
                        widgetDetails={widgetDetails}
                        canvasDataParams={canvasDataParams}
                        isEditMode={isEditMode}
                    />
                )}
            </>
        );
    };

    render(){
        const { widgetDetails, config } = this.props;

        return (
            <Widget
                widgetDetails={widgetDetails}
                exportToCSV={this.onExportToCSV}
                config={config}
                content={ this.generateContent() }
            />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => ( {
    config: widgetsByIdSelector( state )[props.id],
    isEditMode: isEditModeSelector( state ),
} );

WidgetContainer.propTypes = {
    canvasDataParams: PropTypes.object.isRequired,
    config: PropTypes.shape( {
        type: PropTypes.string.isRequired,
    } ),
    exportToCSV: PropTypes.func,
    id: PropTypes.number.isRequired,
    isEditMode: PropTypes.bool,
    widgetDetails: PropTypes.object.isRequired,
};


export default connect( mapStateToProps, { exportToCSV } )( WidgetContainer );
